// utils/stripS3Prefix.ts

export function extractS3Path(url: string): string {
  try {
    const parsed = new URL(url);
    return parsed.pathname.replace(/^\/+/, ""); // remove leading slash
  } catch {
    return url; // fallback if not a valid URL
  }
}
